import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t, i18n } = useTranslation();

  const getLocalizedPath = (path: string) => {
    return i18n.language === 'en' ? path : `/${i18n.language}${path}`;
  };

  return (
    <footer className="bg-primary text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-24">
          {/* Company Info */}
          <div className="space-y-6">
            <Link to={getLocalizedPath('/')} className="text-primary font-bold text-2xl inline-block">
              <img 
                src="/logo1-white.svg" 
                alt="Company Logo" 
                className="h-24 w-auto"
              />
            </Link>
            <p className="text-white/70 leading-relaxed">
              {t('footer.tagline')}
            </p>
            <p className="text-white/70 leading-relaxed">
              {t('footer.contact.question')}{' '}
              <a 
                href="mailto:contact@bridgeonce.com" 
                className="text-secondary hover:text-secondary/80 transition-colors duration-200"
              >
                contact@bridgeonce.com
              </a>
            </p>
          </div>

          {/* Product */}
          <div className="space-y-6 md:pl-12">
            <h3 className="text-lg font-semibold">{t('footer.product.title')}</h3>
            <ul className="space-y-4">
              {[
                ['howitworks', getLocalizedPath('/#process')],
                ['features', getLocalizedPath('/#features')],
                ['faq', getLocalizedPath('/faq')]
              ].map(([key, path]) => (
                <li key={key}>
                  <Link
                    to={path}
                    onClick={(e) => {
                      if (window.location.pathname === getLocalizedPath('/') && (path.includes('/#process') || path.includes('/#features'))) {
                        e.preventDefault();
                        document.getElementById(path.slice(path.indexOf('#') + 1))?.scrollIntoView({ behavior: 'smooth' });
                      }
                    }}
                    className="text-white/70 hover:text-secondary transition-colors duration-200"
                  >
                    {t(`footer.product.links.${key}`)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div className="space-y-6 md:pl-12">
            <h3 className="text-lg font-semibold">{t('footer.company.title')}</h3>
            <ul className="space-y-4">
              {[
                ['aboutus', '/about'],
                ['contactus', '/about#contact'],
                ['privacypolicy', '/privacy'],
                ['termsofservice', '/terms']
              ].map(([key, path]) => (
                <li key={key}>
                  <Link
                    to={path}
                    onClick={() => {
                      if (key === 'aboutus' && window.location.pathname === '/about') {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                      }
                    }}
                    className="text-white/70 hover:text-secondary transition-colors duration-200"
                  >
                    {t(`footer.company.links.${key}`)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white/60 text-sm">
              {t('footer.copyright')}
            </p>
            <div className="flex space-x-6">
              <Link
                to="/privacy"
                className="text-white/60 hover:text-secondary text-sm transition-colors duration-200"
              >
                {t('footer.legal.links.privacy')}
              </Link>
              <Link
                to="/terms"
                className="text-white/60 hover:text-secondary text-sm transition-colors duration-200"
              >
                {t('footer.legal.links.terms')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
} 